module.exports = __webpack_public_path__ + "static/media/loading.337899df.svg";